import React from 'react';
import { useCustomComponent } from '@/hooks';

export interface WidgetButtonIconContainerProps {
  children: React.ReactNode;
  className?: string;
}

const IconContainerComponent: React.FC<WidgetButtonIconContainerProps> = ({
  children,
  className,
}) => {
  return <div className={className}>{children}</div>;
};

export const IconContainer: React.FC<WidgetButtonIconContainerProps> = (
  props: WidgetButtonIconContainerProps
) => {
  const Component = useCustomComponent({
    componentName: 'WidgetButtonIconContainer',
    Component: IconContainerComponent,
  });

  return <Component {...props} />;
};
